export interface LiveScore {
  id: string;
  league: string;
  time: string;
  home: string;
  homeScore: number;
  away: string;
  awayScore: number;
  minute: string;
  status: "live" | "finished" | "upcoming";
  homeOdds?: string;
  drawOdds?: string;
  awayOdds?: string;
  isHot?: boolean;
}

export const liveScores: LiveScore[] = [
  {
    id: "ls1",
    league: "프리미어리그",
    time: "14:00",
    home: "첼시",
    homeScore: 2,
    away: "아스널",
    awayScore: 1,
    minute: "67'",
    status: "live",
    homeOdds: "1.85",
    drawOdds: "3.40",
    awayOdds: "4.20",
    isHot: true,
  },
  {
    id: "ls2",
    league: "분데스리가",
    time: "16:30",
    home: "바이에른 뮌헨",
    homeScore: 0,
    away: "도르트문트",
    awayScore: 0,
    minute: "12'",
    status: "live",
    homeOdds: "1.45",
    drawOdds: "4.50",
    awayOdds: "6.00",
    isHot: true,
  },
  {
    id: "ls3",
    league: "KBO",
    time: "19:00",
    home: "삼성",
    homeScore: 3,
    away: "LG",
    awayScore: 5,
    minute: "8회초",
    status: "live",
    homeOdds: "2.10",
    drawOdds: "-",
    awayOdds: "1.75",
  },
  {
    id: "ls4",
    league: "LCK",
    time: "18:00",
    home: "T1",
    homeScore: 1,
    away: "Gen.G",
    awayScore: 2,
    minute: "3세트",
    status: "live",
    homeOdds: "1.90",
    drawOdds: "-",
    awayOdds: "1.90",
    isHot: true,
  },
  {
    id: "ls5",
    league: "프리미어리그",
    time: "12:30",
    home: "리버풀",
    homeScore: 3,
    away: "맨체스터 유나이티드",
    awayScore: 1,
    minute: "종료",
    status: "finished",
    homeOdds: "1.60",
    drawOdds: "3.80",
    awayOdds: "5.50",
    isHot: true,
  },
  {
    id: "ls6",
    league: "라리가",
    time: "22:00",
    home: "레알 마드리드",
    homeScore: 2,
    away: "AT 마드리드",
    awayScore: 2,
    minute: "종료",
    status: "finished",
    homeOdds: "1.55",
    drawOdds: "3.60",
    awayOdds: "6.00",
  },
  {
    id: "ls7",
    league: "KBO",
    time: "17:00",
    home: "NC",
    homeScore: 7,
    away: "롯데",
    awayScore: 4,
    minute: "종료",
    status: "finished",
    homeOdds: "1.95",
    drawOdds: "-",
    awayOdds: "1.85",
  },
  {
    id: "ls8",
    league: "프리미어리그",
    time: "20:00",
    home: "토트넘",
    homeScore: 0,
    away: "리버풀",
    awayScore: 0,
    minute: "-",
    status: "upcoming",
    homeOdds: "2.50",
    drawOdds: "3.30",
    awayOdds: "2.75",
    isHot: true,
  },
  {
    id: "ls9",
    league: "라리가",
    time: "22:30",
    home: "레알 마드리드",
    homeScore: 0,
    away: "바르셀로나",
    awayScore: 0,
    minute: "-",
    status: "upcoming",
    homeOdds: "2.20",
    drawOdds: "3.40",
    awayOdds: "3.10",
    isHot: true,
  },
  {
    id: "ls10",
    league: "NBA",
    time: "02:30",
    home: "골든스테이트",
    homeScore: 0,
    away: "LA 레이커스",
    awayScore: 0,
    minute: "-",
    status: "upcoming",
    homeOdds: "1.75",
    drawOdds: "-",
    awayOdds: "2.05",
    isHot: true,
  },
];

export const leagueList = [
  "전체",
  "프리미어리그",
  "라리가",
  "분데스리가",
  "세리에A",
  "K리그1",
  "KBO",
  "MLB",
  "NBA",
  "LCK",
  "LPL",
  "V리그",
];